import { useRef } from "react";
import { Button } from "@/components/ui/button";
import { Eraser, PenTool } from "lucide-react";

// ---- Simple signature pad (canvas + touch/mouse) ----
export function SignaturePad({ onDataUrl }) {
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const last = useRef(null);

  const start = (e) => {
    drawing.current = true;
    last.current = getPos(e);
  };
  const move = (e) => {
    if (!drawing.current) return;
    e.preventDefault();
    const p = getPos(e);
    const ctx = canvasRef.current.getContext("2d");
    ctx.strokeStyle = "#0f172a";
    ctx.lineWidth = 2;
    ctx.lineCap = "round";
    ctx.beginPath();
    ctx.moveTo(last.current.x, last.current.y);
    ctx.lineTo(p.x, p.y);
    ctx.stroke();
    last.current = p;
  };
  const end = () => {
    if (!drawing.current) return;
    drawing.current = false;
    onDataUrl(canvasRef.current.toDataURL("image/png"));
  };
  const clear = () => {
    const c = canvasRef.current;
    c.getContext("2d").clearRect(0, 0, c.width, c.height);
    onDataUrl("");
  };
  const getPos = (e) => {
    const rect = canvasRef.current.getBoundingClientRect();
    const t = e.touches?.[0];
    const cx = t ? t.clientX : e.clientX;
    const cy = t ? t.clientY : e.clientY;
    return { x: cx - rect.left, y: cy - rect.top };
  };

  return (
    <div className="border border-slate-300 rounded-lg bg-white">
      <canvas
        ref={canvasRef}
        width={480}
        height={140}
        className="w-full touch-none cursor-crosshair"
        onMouseDown={start}
        onMouseMove={move}
        onMouseUp={end}
        onMouseLeave={end}
        onTouchStart={start}
        onTouchMove={move}
        onTouchEnd={end}
      />
      <div className="flex items-center justify-between px-2 py-1 border-t border-slate-200 bg-slate-50">
        <span className="text-xs text-slate-500 flex items-center gap-1">
          <PenTool className="w-3 h-3" /> Sign above
        </span>
        <Button variant="ghost" size="sm" onClick={clear} className="h-6 gap-1 text-xs">
          <Eraser className="w-3 h-3" /> Clear
        </Button>
      </div>
    </div>
  );
}
